import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";

import ScheduleListComponent from "../schedule/ScheduleListComponent";
import axios from "axios";
// import SchedulegroupDeleteService from "../../_services/schedulegroup/SchedulegroupDeleteService";

const SchedulegroupListComponent = (props) => {

  const {t} = props;
  const [schedulegroup, setSchedulegroup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  const [expandedRows, setExpandedRows] = useState(null);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/schedule-group" + query,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setSchedulegroup(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
      window.App.setState({rerenderSchedulegroupList: false})
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_schedule_write') &&
        <>
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip="Módosítás" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    window.App.setState({
                      sidebarSchedulegroupUpdate: true,
                      props: rowData
                    })
                  }}/>
          <Button icon="pi pi-plus" className="  p-button-success p-mr-2"
                  tooltip="Új műszak"
                  onClick={() => {
                    window.App.setState({
                      sidebarScheduleCreate: true,
                      props: rowData
                    })
                  }}/>
          <Button icon="pi pi-calendar" className=" p-button p-mr-2"
                  tooltip="Megtekintés" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    window.App.setState({
                      sidebarSchedulegroupShow: true,
                      props: rowData
                    })
                  }}/>
        </>
        }
        <Button icon="pi pi-trash" className="p-button-danger"
                tooltip="Törlés" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  if (window.confirm('A törlés megerősítésére van szükség!')) {
                    axios.delete(process.env.REACT_APP_API_HOST + "/api/v2/schedule-group/" + rowData.id,
                      {
                        params: {},
                        headers: {
                          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                          'App-Network': localStorage.getItem("networkId")
                        }
                      })
                      .then(response => {
                        window.App.toastShow('success', 'Sikeres törlés!',);
                        loadLazyData();
                      })
                      .catch(error => {
                        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                      })
                  }
                }}
        />
      </React.Fragment>
    );
  }

  const rowExpansionTemplate = (data) => {
    return (
      <>
        <div className="p-ml-3">
          <ScheduleListComponent groupId={data.id} groupName={data.name} type={data.type} />
          {/*<DataTable size={localStorage.getItem('scale')} value={scheduleData}*/}
          {/*           emptyMessage="Nincs találat."*/}
          {/*           autoLayout={true}*/}
          {/*           filterDisplay="row"
            responsiveLayout="scroll"*/}
          {/*           stripedRows*/}
          {/*           className={"p-mb-3"}*/}
          {/*>*/}
          {/*  <Column field="name" header="Név"></Column>*/}
          {/*</DataTable>*/}
        </div>
      </>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderSchedulegroupList === true])

  return (
    <>
      {props && props.view === 'simple' &&
        <>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              {localStorage.getItem('roles').toString().includes('role_schedule_write') &&
                <a onClick={() => window.App.setState({sidebarSchedulegroupCreate: true})}
                   className={"p-button  p-button-success p-ml-md-2 p-my-1 p-my-lg-0"}>
                  <i className={"pi pi-plus"}></i>
                  &nbsp;
                  Új műszak csoport
                </a>
              }
            </div>
          </div>
        </>
      }
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage="Nincs találat."
        value={schedulegroup} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        dataKey="id"
        rowExpansionTemplate={rowExpansionTemplate}
        expandedRows={expandedRows}
        onRowExpand={(e) => {
          let id = e.data.id
          setExpandedRows({[id]: true})
          window.App.setState({
            valueSchedulegroupId: e.data.id
          })
          // ScheduleListService(e.data.id)
          //   .then(response => {
          //     setScheduleData(response.data.items)
          //   })
          //   .catch(error => {
          //     window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          //   })
        }}
      >
        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
        <Column field="type" header="Típus" sortable filter filterPlaceholder="Típus" body={(rowData) => {
          if(rowData.type == 'EMPLOYEE_CAPACITY') {
            return(
              <>Munkavállalók beosztása</>
            )
          }
          if(rowData.type == 'MACHINE_CAPACITY') {
            return(
              <>Berendezés kapacitás beosztása</>
            )
          }
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        <Column expander style={{width: '3em'}}/>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(SchedulegroupListComponent);
